<template>
	<div class="publicity-content protect-content">
		<div class="list-box">
			<ss-article-list :value="curData_" mode="9" detailPath="/lch/protect/" />
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssArticleList from '@/components/ss-article-list/ss-article-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		data() {
			return {
				typeList: [{
					value: 'dxfydxfyccbh',
					label: '传承保护'
				}]
			}
		},
		components: {
			ssArticleList
		}
	}
</script>

<style lang="scss">
	@import '~@/views/lch/css/publicity.scss';
	.protect-content{
		.list-box{
			background-color: #fff;
		}
	}
</style>
